import {
  getGridNumericOperators,
  getGridStringOperators,
} from "@mui/x-data-grid-premium";

const backendStringOperators = getGridStringOperators().filter(
  (operator) => operator.value === "contains"
);

// Backend-filtered string columns support partial matching by default.
export const stringFilterOperators = backendStringOperators;

// Exact matching is enabled separately behind the UX update feature flag.
export const stringFilterOperatorsWithEquals = getGridStringOperators().filter(
  (operator) => operator.value === "contains" || operator.value === "equals"
);

// Default numeric ops; isEmpty/isNotEmpty (null checks) are opt-in per column.
export const backendNumericOperators = getGridNumericOperators().filter(
  (operator) =>
    operator.value !== "isEmpty" &&
    operator.value !== "isNotEmpty" &&
    operator.value !== "isAnyOf"
);
